export function countLines(str: string): number {
  const lines = str.split("\n");

  return lines.length;
}

export function toLines(str: string): readonly string[] {
  return str.replaceAll("\r\n", "\n").split("\n");
}

export function unpad(str: string): string {
  const lines = toLines(str.trimEnd());

  const smallestPadding = Math.min(
    ...lines
      .filter(line => line.trim())
      .map(line => {
        const trimmed = line.trimStart();

        return line.length - trimmed.length;
      }),
  );

  return lines
    .map(line => line.slice(smallestPadding))
    .join("\n")
    .trim();
}
